// extracted by mini-css-extract-plugin
export var content = "_nm-1";
export var noScroll = "_nm-3";
export var paper = "_nm-0";
export var scrollable = "_nm-2";